import React, { useContext, useState } from 'react';

import { ArrowRightIcon, CloseIcon } from '$partials/icon';
import { ModalContext } from '$contexts/modal.jsx';
import { Button } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modals.d.ts').SortByModal}
 */
const SortByModal = ({
    orderBy,
    orderByOptions,
    setOrderBy,
    setActiveFilter
}) => {
    const { handleModal } = useContext(ModalContext);

    return (
        <div className={'fixed left-0 top-0 height-100 width-100 border-0 m0 p0 overflow-auto bg-white z3 flex flex-wrap'}>
            <div
                className='absolute top-0 width-100 z5 pt5 px5 flex justify-between'>
                <p className='type-style-5'>Sort By</p>
                <Button
                    aria-label='Close'
                    as = 'button'
                    look = 'button'
                    onClick={() => {
                        setActiveFilter('');
                        handleModal();
                    }}
                    renderIcon = {<CloseIcon/>}/>
            </div>
            <div className='col-12 px5 pt13 flex flex-wrap height-0'>
                {orderByOptions?.map((order, idx) => {
                    return (
                        <div
                            className='col-12 sm-col-6'
                            key={order.id}>
                            <button
                                className={`col-6 form-field-reset link-reset cursor-pointer${orderBy === order.value ? ' bg-yellow ' : ''}button inline-flex width-100 pl5 md-pl6 pr6 pt6 pb6 md-pt5 md-pb5 border-left border-right border-bottom sm-border-0 sm-border-top${!idx ? ' border-top' : ''}${idx % 2 === 0 ? ' sm-border-left sm-border-right' : ' sm-border-right'} ${idx > 1 ? ' sm-border-bottom' : ''}`}
                                onClick={() => {
                                    setOrderBy(order.value);
                                    setActiveFilter('');
                                    handleModal();
                                }}
                                type='button'>
                                <span className='flex flex-col width-100'>
                                    <p className='type-style-5 align-left py2'>{order.category}</p>
                                    <div className='flex justify-between items-center'>
                                        <h3 className='type-style-3'>{order.label}</h3>
                                        <span
                                            aria-hidden={true}
                                            className='font-0 line-height-0 p3 md-p5'>
                                            <ArrowRightIcon/>
                                        </span>
                                    </div>
                                </span>
                            </button>
                        </div>);
                })}
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default SortByModal ;
